/**
 * src/credits.js
 *
 * Static credits/about panel content shown from the sidebar.
 *
 * Kept separate from app.jsx because it is pure presentation content with no
 * runtime wiring, and it changes on a different cadence from the main app
 * orchestration code.
 */

const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "unknown";

const Credits = () => (
  <div class="credits-panel">
    <p>
      Designed by <a href="http://siementerpstra.com/">Siemen Terpstra</a> based on{" "}
      <a href="https://www.anaphoria.com/wilsonkeyboard.html">
        Erv Wilson's microtonal keyboard designs
      </a>{" "}
      (1967-), inspired by{" "}
      <a href="https://en.wikipedia.org/wiki/Robert_Holford_Macdowall_Bosanquet">
        R.H.M. Bosanquet
      </a>
      's <a href="https://en.wikipedia.org/wiki/Generalized_keyboard">Generalised Keyboard</a>{" "}
      (1873) and Ivo Salzinger's <em>Tastatura Nova Perfecta</em> (1721).
    </p>
    <p>
      Initial development by James Fenn with additions and modifications from{" "}
      <a href="http://brandlew.com/">Brandon&nbsp;Lewis</a>,{" "}
      <a href="http://whatmusicreallyis.com/" title="What Music Really İs">
        Bo&nbsp;Constantinsen
      </a>
      , <a href="https://sites.google.com/site/wangchengu/">Chengu&nbsp;Wang</a>,{" "}
      <a href="https://ashton.snelgrove.science">Ashton&nbsp;Snelgrove</a>. Sampling credits to
      Scott&nbsp;Thompson, Tim&nbsp;Kahn, Carlos&nbsp;Vaquero, Dr.&nbsp;Ozan&nbsp;Yarman, Lars Palo,
      and Soni Musicae.
    </p>
    <p>
      Designed and programmed by <a href="https://www.plainsound.org">Marc&nbsp;Sabat</a>. Current
      version {APP_VERSION} (August 2026), released under{" "}
      <a href="https://www.gnu.org/licenses/gpl-3.0.en.html">GPL-3.0</a>. Open source code at{" "}
      <a href="https://github.com/PLAINSOUND/hexatone">github.com/PLAINSOUND/hexatone</a>. Join the
      community on <a href="https://discord.gg/NGVTmDFPtf">discord</a>.
    </p>
    <p>
      <em>
        The text font with embedded HEJI accidentals (Plainsound Sans) is designed by Thomas
        Nicholson. Unicode data for copying/pasting may be found at{" "}
        <a href="https://w3c-cg.github.io/smufl/latest/tables/extended-helmholtz-ellis-accidentals-just-intonation.html">
          w3c-cg.github.io/smufl/latest/tables
        </a>
        .
      </em>
    </p>
    <p id="donation-link">
      <b>
        Support our open access content with a <a href="https://ko-fi.com/plainsound">donation</a>.
      </b>
      <br />
      cc 2026 <a href="https://www.plainsound.org">PLAINSOUND MUSIC EDITION</a>
    </p>
  </div>
);
export default Credits;
